// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Filter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M.938 1.75A.926.926 0 000 2.688c0 .527.41.937.938.937h2.548a2.325 2.325 0 002.139 1.406c.967 0 1.787-.586 2.139-1.406h6.298c.528 0 .938-.41.938-.938a.926.926 0 00-.938-.937H7.764A2.325 2.325 0 005.625.344c-.967 0-1.787.586-2.139 1.406H.937zm0 4.688A.926.926 0 000 7.375c0 .527.41.938.938.938h7.236a2.325 2.325 0 002.139 1.406c.966 0 1.787-.586 2.138-1.406h1.611c.528 0 .938-.41.938-.938a.926.926 0 00-.938-.938h-1.61a2.325 2.325 0 00-2.14-1.406c-.966 0-1.787.586-2.138 1.407H.938zm0 4.687a.926.926 0 00-.938.938c0 .527.41.937.938.937h1.61a2.325 2.325 0 002.14 1.406c.966 0 1.787-.586 2.138-1.406h7.237c.527 0 .937-.41.937-.938a.926.926 0 00-.938-.937H6.827a2.325 2.325 0 00-2.138-1.406c-.967 0-1.788.586-2.14 1.406H.939z" />
        </svg>
    );
};

export default React.memo(Filter);
